import { appConfig } from '@/config/app.ts'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody'

export interface FilterState {
  isLoading: boolean
  filters: NestedFilterObject
}

export const initialState: FilterState = {
  isLoading: false,
  filters: {
    page: 0,
    limit: appConfig.pagination.defaultValue,
    sortByDate: 'desc'
  }
}
